import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Text, colors } from 'react-orange-ui';

import Thumbnail from './Thumbnail';
import { removeLastImageCaptcha } from '../../actions/captcha_actions';
import device from '../../helpers/breakpoints';

export const IndicationStatus = {
  PREVIOUS: 'PREVIOUS',
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
  LAST: 'LAST',
};

const bgColorChooser = ({ theme }) => {
  switch (theme) {
    case IndicationStatus.CURRENT:
      return colors.orange2;
    case IndicationStatus.PREVIOUS:
      return colors.black;
    case IndicationStatus.LAST:
      return colors.black;
    default:
      return colors.grey6;
  }
};

const colorChooser = ({ theme }) => {
  switch (theme) {
    case IndicationStatus.CURRENT:
      return 'white';
    case IndicationStatus.PREVIOUS:
      return 'white';
    case IndicationStatus.LAST:
      return 'white';
    default:
      return 'black';
  }
};

const Indication = styled.li`
  display: flex;
  list-style: none;
  
  @media ${device.mobile} {
    display: ${props => (props.status === IndicationStatus.NEXT ? 'none' : '')};
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 0.5rem 1rem;
  margin-top: 2px;
  height: auto;
  width: 250px;
  background-color: ${props => props.backgroundColor};
  clip-path: polygon(0% 0%,90% 0%,100% 50%, 90% 100%, 0% 100%); // Create polygon form
`;

function getIndicationStatus(key, array) {
  let indicationStatus = IndicationStatus.NEXT;
  if (array.length > key) {
    indicationStatus = IndicationStatus.PREVIOUS;
  }
  if (array.length - 1 === key) {
    indicationStatus = IndicationStatus.LAST;
  }
  if (array.length === key) {
    indicationStatus = IndicationStatus.CURRENT;
  }
  return indicationStatus;
}

const Indications = (props) => {
  const {
    images,
    indications,
  } = props;
  const indicationsElement = indications.map((indication, key) => {
    const status = getIndicationStatus(key, images);
    const id = `captcha-indication-${key + 1}`;
    return (
      <Indication id={id} key={key} status={status}>
        <Wrapper backgroundColor={bgColorChooser({ theme: status })}>
          <Text bold color={colorChooser({ theme: status })} size="l">
            {`${key + 1} ${indication}`}
          </Text>
        </Wrapper>
        <Thumbnail image={images[key]} status={status} indication={indication} />
      </Indication>
    );
  });

  return (
    <ol id="captcha-indications" style={{ padding: 0 }}>
      {indicationsElement}
    </ol>
  );
};

Indications.defaultProps = {
  images: [],
};

Indications.propTypes = {
  /** User input captcha status */
  images: PropTypes.arrayOf(PropTypes.shape({
    format: PropTypes.string,
    value: PropTypes.number,
    data: PropTypes.string,
  })),
  /** User input captcha status */
  indications: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = status => ({
  images: status.captcha.selectedImages,
});

const mapDispatchToProps = dispatch => ({
  removeLastImageCaptcha: () => dispatch(removeLastImageCaptcha()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Indications);
